import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AppStore } from '../store/app-store';

export const COMPANY_HEADER = 'X-Company-Id';

export const companyInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = environment.apiUrl.replace(/\/+$/, '');

  if (req.url.startsWith(apiUrl + '/')) {
    const appStore = inject(AppStore);
    const companyId = appStore.companyId();
    if (companyId && !req.headers.has(COMPANY_HEADER)) {
      const newReq = req.clone({
        headers: req.headers.append('X-Company-Id', `${companyId}`),
      });
      return next(newReq);
    }
  }

  return next(req);
};
